const ChevronDownIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%', rotate: '180' }}
            src="/images/chevron-up-icon.svg"
            alt="Document Icon"
        />
    );
};

export default ChevronDownIcon;
